// import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const[ w, l, mq ] = [ window, location, window.matchMedia( "(max-width: 900px)" ) ];

const init = () => {

  w.jQuery = $;

  $.when(
    w.load['mainvisual'],
    $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
  ).then( () => {
    const $MV = $('[data-plugin="ytplayer"]');
    const param = id => `{
      videoURL: '${id}',
      containment: '.mainvisual__body',
      mute: true,
      showControls: false,
      autoPlay: true,
      useOnMobile: true,
      showYTLogo: false,
      abundance: '${(mq.matches)? 0.01: 0.07}',
      stopMovieOnBlur: false,
      loop: true,
      startAt: 0,
      anchor: 'center,center',
      quality: 'default'
    }`.replace(/\n|\s/g,'');
    $MV.attr('data-property',param('sIXehZ6KyjI'));
    $MV.YTPlayer();
    $MV.YTPPlay();
  });

  // ticker
  $.when( w.load['mainvisual'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="date hidden-xsmall">${item.date}</span>
        <span class="cat hidden-xsmall">[${item.category.name}]</span>
        <span class="subject">${item.title.str_truncate(30)}</span>
      </a>
    `)[0];
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem });
  });

  // NEWS
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
    <li class="block-news-item ${item.is_new ? 'is-new': ''}">
      <a href="${item.href}">
        <div class="block-news-item__body">
          <span class="date-cate">
            <span class="date">${item.date}</span>
            <span class="cate">${item.category.name}</span>
          </span>
          <span class="subject">${item.title}</span>
        </div>
      </a>
    </li>
    `)[0];
    GET_ARTICLES( '.block-news__list[data-plugin="getArticles"]', { makeItem });
  });

}

export default function HOME() {
  $( init )
}